import { Box, BoxProps, Icon, Typography, Link } from "@xcorejs/ui";
import CloseIconSmall from "components/Icons/8/close.svg";
import Cookies from "js-cookie";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useLayout } from "xcore";
import { ScrollBarBoxStyle } from "./NavItem/NavItemDropdown";

type RegionInfoProps = BoxProps & {
  close: boolean;
  setClose: Dispatch<SetStateAction<boolean>>;
  isTop?: boolean;
};

export const RegionInfo = ({ close, setClose, isTop, ...props }: RegionInfoProps) => {
  const { stringify, general } = useLayout();
  const isCookie = Cookies.get("multiple-visit") === "1";
  const [windowWidth, setWindowWidth] = useState<number | null>(null);

  useEffect(() => {
    const handleSetWindowWidth = () => setWindowWidth(window.innerWidth);

    handleSetWindowWidth();

    window.addEventListener("resize", handleSetWindowWidth);
    return () => window.removeEventListener("resize", handleSetWindowWidth);
  }, []);

  if (close || isCookie || !windowWidth) {
    return null;
  }

  return (
    <ScrollBarBoxStyle
      bg="#e7e7e7"
      position="absolute"
      boxShadow="0 0.3rem 0.5rem 0 rgba(30, 30, 30, 0.5)"
      width="25rem"
      mt={{ md: "4rem" }}
      top={{ _: isTop ? "1.6rem" : "5rem", md: "unset" }}
      transform={{ _: isTop ? "translateX(50%)" : "none", md: "none" }}
      right={{ _: isTop ? "50%" : "0", md: windowWidth > 1024 && windowWidth < 1427 ? "1%" : "-6.8rem" }}
      display={close ? "none" : props.display}
      cursor="auto"
      _hover={{ boxShadow: "0 0.8rem 0.8rem 0 rgba(30, 30, 30, 0.5)" }}
    >
      <Box
        height="2rem"
        width="2rem"
        bg="#e7e7e7"
        position="absolute"
        top="-1rem"
        right={isTop === false ? "37%" : windowWidth > 1024 && windowWidth < 1427 ? "20%" : "50%"}
        transform="rotate(45deg)"
      />
      <Box position="absolute" right="0" top="0">
        <Link
          type="simple"
          v="simple"
          justifyContent="center"
          alignItems="center"
          onClick={() => {
            setClose(true);
            Cookies.set("multiple-visit", "1", { expires: 365 * 2 });
          }}
        >
          <Icon m="1.3rem" svg={<CloseIconSmall />} fill="#747474" fillHover="black" />
        </Link>
      </Box>
      <Typography fontSize="1.4rem" lineHeight="2.5rem" overflow="hidden" textAlign="center" p="3.2rem 2rem 2rem 2rem">
        {stringify(general.values.regionInfoBubble)}
      </Typography>
    </ScrollBarBoxStyle>
  );
};
